module.exports = __webpack_public_path__ + "img/company.319b06d0.png";